import linkIcon from "@assets/social_media/copyShare.svg";
import facebookIcon from "@assets/social_media/facebookShare.svg";
import whatsappIcon from "@assets/social_media/whatsppShare.svg";
import xIcon from "@assets/social_media/xShare.svg";
import LinkIcon from "@elements/Icon/LinkIcon";
import { removeLeadingSlash } from "@helper/removeTrailingLeadingSlash";
import { getWindowOrigin } from "@helper/utils";
import { useTablaCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useTablaCustomEventAnalyticsCall";

export type SocialVariant =
  "facebook" | "copylink" | "x" | "whatsapp" | "plainWhatsapp";

export type ShareSocialProps = {
  variant: SocialVariant;
  pageTitle?: string;
  pagePath: string;
  width?: string;
};

export default function ShareSocial({
  variant,
  pageTitle,
  pagePath,
}: ShareSocialProps) {
  const origin = getWindowOrigin();
  const shareTitle = pageTitle && encodeURIComponent(pageTitle);
  const sharePath = encodeURIComponent(
    `${origin}/${removeLeadingSlash(pagePath)}`,
  );
  const xDestination = shareTitle
    ? `${sharePath}&text=${shareTitle}`
    : sharePath;
  const whatsappDestination = shareTitle
    ? `${shareTitle}%0A${sharePath}`
    : sharePath;

  const TablaCustomGaEvent = useTablaCustomEventAnalyticsCall();
  const handleShareClick = (platform: string) => {
    TablaCustomGaEvent({
      event: "customEvent",
      clickCategory: "share",
      clickAction: platform,
      clickLabel: `${origin}/${removeLeadingSlash(pagePath)}`,
    });
  };

  switch (variant) {
    case "facebook":
      return (
        <div className="flex items-center justify-center  bg-yellow-100 rounded-whatsapp h-[28px] w-[28px] rounded-full gap-1">
          <LinkIcon
            onClick={() => {
              handleShareClick("facebook");
            }}
            destination={`https://www.facebook.com/sharer/sharer.php?u=${sharePath}`}
            src={facebookIcon}
            alt="facebook"
            height="18px"
            width="18px"
            className="p-1"
          />
        </div>
      );
    case "x":
      return (
        <div className="flex items-center justify-center bg-yellow-100 rounded-whatsapp h-[28px] w-[28px] rounded-full gap-1">
          <LinkIcon
            onClick={() => {
              handleShareClick("x");
            }}
            destination={`https://twitter.com/intent/tweet?url=${xDestination}`}
            src={xIcon}
            alt="x"
            height="18px"
            width="18px"
            className="p-1"
          />
        </div>
      );
    case "whatsapp":
      return (
        <div className="flex items-center justify-center  bg-yellow-100 rounded-whatsapp h-[28px] w-[28px] rounded-full gap-1">
          <LinkIcon
            onClick={() => {
              handleShareClick("whatsapp");
            }}
            destination={`https://wa.me/?text=${whatsappDestination}`}
            src={whatsappIcon}
            alt="whatsapp"
            height="18px"
            width="18px"
            className="p-1"
          />
        </div>
      );
    case "copylink":
      return (
        <div className="flex items-center justify-center  bg-yellow-100 rounded-whatsapp h-[28px] w-[28px] rounded-full gap-1">
          <LinkIcon
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              e.stopPropagation();
              handleShareClick("copylink");
              void navigator.clipboard.writeText(`${origin}${pagePath}`);
              alert("Link Copied!");
            }}
            destination={"#"}
            src={linkIcon}
            alt="copylink"
            height="18px"
            width="18px"
            className="p-1"
          />
        </div>
      );
    case "plainWhatsapp":
      return (
        <LinkIcon
          height="18px"
          width="18px"
          destination={`https://wa.me/?text=${whatsappDestination}`}
          src={linkIcon}
          alt="sharelink"
        />
      );
    default:
      return null;
  }
}
